import { MongoModel } from 'src/app/shared/models/_mongo.model';
export class Audit extends MongoModel {
    constructor() {
        super(...arguments);
        this.displayType = 0;
        this.auditNodes = [];
    }
}
